module.exports = __webpack_public_path__ + "img/w52.37613acf.svg";